export const related = [
  '/puzzles/atlantis-code-the-park',
  '/puzzles/urban-fresh-code',
  '/puzzles',
];
export const quickAnswer =
  'Wall box → Radio → Dark coffee maker → White coffee maker → Soda machine → Microwave → Fridge.';
export const sourceIds = ['powerpyx-hideouts'];
export const diagram = {
  src: '/diagrams/downtown-atlantis-order.svg',
  alt: 'Downtown Atlantis seven-object order: wall box, radio, dark coffee maker, white coffee maker, soda machine, microwave, fridge.',
  width: 1200,
  height: 310,
};

## Atlantis Restaurant Location

Use the Atlantis Restaurant in Downtown. The Park has a different Atlantis puzzle.

## Correct Object Order

1. Wall box in the back-right corner.
2. Radio on the left from the entrance.
3. Dark coffee maker on the counter.
4. White coffee maker on the shelf behind the counter.
5. Soda machine.
6. Microwave.
7. Fridge behind the counter.

## How to Know the Puzzle Succeeded

The hidden room opens. Enter and collect the health-upgrade item.

## Wall Not Opening?

Check the two coffee makers in particular: dark comes before white. Confirm the zone and work through the displayed order rather than using the Park's register code.
